// extracted by mini-css-extract-plugin
module.exports = {"container":"Categories_container__4ENgW","subtitle":"Categories_subtitle__2X4wg","categories":"Categories_categories__33X1P"};